<template>
    <article
        v-for="item in archiveItemsData.data"
        :key="item.name"
        :data-title="item.name"
        class="a-a-archive-item"
        ref="article">
        <div
            class="a-a-archive-item__wrapper"
            @click="toggleHeight">
            <h3 class="a-a-archive-item__title">
                {{ item.name }}
            </h3>
            <div class="a-a-archive-item__date">
                Материалы с {{ Object.values(item)[1] }} г. по {{ Object.values(item)[2] }} г.
            </div>
        </div>

        <div
            class="a-a-archive-item__content"
            ref="dropdown">
            <div
                class="a-a-archive-item__tabs"
                ref="reverseContainer">
                <button
                    v-for="(tab, name, i) in item.items"
                    :key="'tab-' + tab[0].id"
                    :data-index="i"
                    @click="setTabActive"
                    class="a-a-archive-item__tab"
                    type="button">
                    {{ name }}
                </button>
            </div>
            <div
                class="a-a-archive-item__links-wrap"
                ref="reverseContainer">
                <div
                    v-for="(tab, name, i) in item.items"
                    :key="'tab-' + tab[0].id"
                    :data-index="i"
                    class="a-a-archive-item__dropdown">
                    <ul class="a-a-archive-item__list">
                        <li
                            v-for="link in tab"
                            :key="link.id">
                            <template v-if="link.props.link_to_report">
                              <a
                                  class="a-a-archive-item__link"
                                  :href="link.props.link_to_report"
                                  >
                                <div class="a-a-archive-item__link-wrap">
                                    <span class="a-a-archive-item__text"
                                          v-html="link.props.file.name"></span>
                                  <div class="a-a-archive-item__date-wrap">
                                    <div style="display: flex; gap: 8px">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.68746 6.00037C5.68746 5.44808 6.13518 5.00037 6.68746 5.00037H17C17.5523 5.00037 18 5.44808 18 6.00037V16.3129C18 16.8652 17.5523 17.3129 17 17.3129C16.4477 17.3129 16 16.8652 16 16.3129V8.4146L6.70711 17.7076C6.31659 18.0981 5.68342 18.0981 5.2929 17.7076C4.90237 17.3171 4.90237 16.6839 5.29289 16.2934L14.5858 7.00037H6.68746C6.13518 7.00037 5.68746 6.55265 5.68746 6.00037Z" fill="#82BF00"/>
                                      </svg>
                                      <span class="a-a-archive-item__format">
                                           Смотреть отчет
                                        </span>
                                    </div>

                                    <span class="a-a-archive-item__format a-a-archive-item__format_grey">
                                            {{ link.props.file.date }}
                                        </span>
                                  </div>
                                </div>
                              </a>
                            </template>
                            <template v-else>
                              <a
                                  class="a-a-archive-item__link"
                                  :href="link.props.file.src"
                                  :title="link.props.file.name"
                                  :download="link.props.file.name">
                                <div class="a-a-archive-item__link-wrap">
                                    <span class="a-a-archive-item__text"
                                          v-html="link.props.file.name"></span>
                                  <div class="a-a-archive-item__date-wrap">
                                    <div style="display: flex; gap: 8px">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.50037C12.5523 1.50037 13 1.94808 13 2.50037V12.1775L15.8271 9.35117C16.2177 8.9607 16.8508 8.96078 17.2413 9.35136C17.6318 9.74193 17.6317 10.3751 17.2411 10.7656L12.707 15.2985C12.3165 15.6889 11.6835 15.6889 11.293 15.2985L6.75889 10.7656C6.36832 10.3751 6.36824 9.74193 6.75871 9.35136C7.14918 8.96078 7.78235 8.9607 8.17292 9.35117L11 12.1775V2.50037C11 1.94808 11.4477 1.50037 12 1.50037ZM3 15.0004C3.55228 15.0004 4 15.4481 4 16.0004V21.0004H20V16.0004C20 15.4481 20.4477 15.0004 21 15.0004C21.5523 15.0004 22 15.4481 22 16.0004V21.2504C22 21.744 21.7853 22.1977 21.4361 22.5179C21.0898 22.8353 20.6373 23.0004 20.1818 23.0004H3.81818C3.36269 23.0004 2.91023 22.8353 2.56392 22.5179C2.21469 22.1977 2 21.744 2 21.2504V16.0004C2 15.4481 2.44772 15.0004 3 15.0004Z" fill="#82BF00"/>
                                      </svg>
                                         <span class="a-a-archive-item__format">
                                            {{ link.props.file.extension.toUpperCase() }}, <span v-html="link.props.file.size"></span>
                                        </span>
                                    </div>

                                    <span class="a-a-archive-item__format a-a-archive-item__format_grey">
                                            {{ link.props.file.date }}
                                        </span>
                                  </div>
                                </div>
                              </a>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'ArchiveItem',
        props: {
            archiveItemsData: Object
        },
        methods: {     
            setTabActive () {
                const targetTab = event.target
                const targetItem = targetTab.closest('.a-a-archive-item')
                this.setDefaultTabsState(targetItem)
                const targetDropdowns = targetItem.querySelectorAll('.a-a-archive-item__dropdown')
                const content = targetItem.querySelector('.a-a-archive-item__content')

                targetTab.classList.add('active')
                targetDropdowns.forEach(el => {
                    if (el.getAttribute('data-index') === targetTab.getAttribute('data-index')) {
                        el.classList.add('active')
                    }
                })
                
                setTimeout(() => {
                    content.style.maxHeight = `${content.scrollHeight}px`
                }, 100);
            },

            toggleHeight () {
                const target = event.target.closest('.a-a-archive-item')
                const content = target.querySelector('.a-a-archive-item__content')
                if (content.offsetHeight !== 0) {
                    content.style.maxHeight = 0
                    target.classList.remove('active')
                } else {
                    content.style.maxHeight = `${content.scrollHeight}px`
                    target.classList.add('active')
                }
            },

            setDefaultTabsState (targetItem) {
                const itemsActiveEl = targetItem.querySelectorAll('.active')
                itemsActiveEl.forEach(el => {
                    el.classList.remove('active')
                })
            },

            setTabActiveOnLoad () {
                const items = document.querySelectorAll('.a-a-archive-item')
                items.forEach(item => {
                    const tabs = item.querySelectorAll('.a-a-archive-item__tab')
                    const content = item.querySelectorAll('.a-a-archive-item__dropdown')
                    this.iterateTabItems(tabs)
                    this.iterateTabItems(content)
                })
            },

            iterateTabItems (elements) {
                elements.forEach((el, i) => {
                    el.classList.remove('active')
                    if (i === 0) el.classList.add('active')
                })
            },

            reverseItems () {
                if (this.$refs.reverseContainer) {
                    this.$refs.reverseContainer.forEach(el => {
                        el.append(...Array.from(el.childNodes).reverse())
                    })
                }
            }
        },

        watch: {
            archiveItemsData() {
                this.reverseItems()
                this.setTabActiveOnLoad()
            }
        },

        mounted() {
            this.reverseItems()
            this.setTabActiveOnLoad()
        },
        
        updated() {
            this.reverseItems()
            this.setTabActiveOnLoad()
        }
    }
</script>